import { Link } from "react-router-dom";

import { DESIGN_PARTNER_PATHS } from "../routes";

export function PrivacyPage() {
  return (
    <section className="page" id="privacy" data-testid="dp-page-privacy">
      <div className="wrap policy">
        <div className="eyebrow">Legal</div>
        <h1>Privacy Policy</h1>
        <p>
          <b>Effective date:</b> August 10, 2026
        </p>
        <div className="notice">
          This policy is a practical launch-ready draft, not legal advice. Have counsel review it
          before operating the site, running paid campaigns, or onboarding customers in jurisdictions
          with additional privacy requirements.
        </div>
        <h2>Information we collect</h2>
        <p>
          When you request a design-partner conversation, we collect the information you submit, such
          as your name, work email, company information, role, project volume, tool stack, and
          project-management challenges. We also collect limited technical information generated by
          normal website operations, such as browser, device, IP address, pages viewed, and referral
          source.
        </p>
        <h2>How we use information</h2>
        <p>
          We use information to respond to your request, assess fit for the design-partner program,
          schedule conversations, understand product needs, improve the site, protect the site from
          abuse, and meet legal obligations. We do not sell personal information.
        </p>
        <h2>How we share information</h2>
        <p>
          We share information only with service providers that help us operate the website, store
          submissions, communicate with you, analyze website performance, or provide security. Those
          providers may use information only to provide services to Zephix. We may also disclose
          information where required by law or to protect rights, safety, and security.
        </p>
        <h2>Retention</h2>
        <p>
          We retain design-partner inquiry information only for as long as reasonably necessary to
          respond, evaluate fit, maintain records, and comply with legal obligations. You may ask us
          to delete your inquiry information, subject to legal and operational retention
          requirements.
        </p>
        <h2>Your choices</h2>
        <p>
          You may request access, correction, or deletion of your information, or opt out of
          non-essential communications, by contacting us through the{" "}
          <Link to={DESIGN_PARTNER_PATHS.contact}>Contact page</Link>. Depending on where you live,
          you may have additional rights under applicable privacy laws.
        </p>
        <h2>Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational safeguards intended to
          protect submitted information. No online system is completely secure, and we cannot
          guarantee absolute security.
        </p>
        <h2>Updates</h2>
        <p>
          We may update this policy as our services evolve. We will post the revised effective date
          on this page.
        </p>
      </div>
    </section>
  );
}
